"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityCreateApi = activityCreateApi;
exports.activityDetailApi = activityDetailApi;
exports.activityListApi = activityListApi;
exports.activityUpdateApi = activityUpdateApi;
exports.drawRecordListApi = drawRecordListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 活动列表
 * @param params
 */
function activityListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/lottery/activity/page',
    method: 'GET',
    params: params
  });
}

/**
 * 新增商品
 * @param data
 */
function activityCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/lottery/activity/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑商品
 * @param data
 */
function activityUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/lottery/activity/update',
    method: 'POST',
    data: data
  });
}

/**
 * 商品详情
 * @param id
 */
function activityDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/lottery/activity/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 抽奖记录列表
 */
function drawRecordListApi(data) {
  return (0, _request.default)({
    url: '/admin/lottery/record/list',
    method: 'post',
    data: data
  });
}